module.exports = __webpack_public_path__ + "static/media/facebook.449b5cc3.svg";